import { isEqual } from "lodash";
import {
  UPDATE_INFLUENCER_PARAMS,
  RESET_FILTERS_INFLUENCERS,
  fetchInfluencers,
} from "./influencer_actions";
import { filters } from "./influencers_reducers";

export default (store) => (next) => (action) => {
  const { influencerParams } = store.getState();
  if (action.type === UPDATE_INFLUENCER_PARAMS) {
    if (!isEqual(influencerParams, action.params)) {
      store.dispatch(
        fetchInfluencers({ ...influencerParams, ...action.params })
      );
    }
  }
  if (action.type === RESET_FILTERS_INFLUENCERS) {
    store.dispatch(fetchInfluencers({ ...influencerParams, filters }));
  }
  return next(action);
};
